import React, { useEffect, useMemo, useState } from "react";
import AlertPeriod from "../../components/alert-period/alert-period";
import Header from "../../components/header/header.component";
import Aside from "../../components/aside/aside.component";
import Footer from "../../components/footer/footer.component";
import { BalanceService } from "../../services/operation/balance";
import { UtilsService } from "../../services/utils";

declare const KTUtil: any;
declare const Chart: any;

function BalancePage() {

  const defaultState = {
    cortes: {
      total_pagos: 0,
      total_valor: 0,
    },
    gastos_compras: {
      total_compra: 0,
      total_gasto: 0,
    },
    prestamos_creditos: {
      total_deuda: 0,
      total_intereses: 0,
      total_pagos: 0,
    },
  }

  const [balance, setBalance] = useState(defaultState);

  const balanceFinal = useMemo(() => {
    return (
      balance.cortes.total_pagos 
      + 
      (balance.cortes.total_valor - balance.cortes.total_pagos)
      -
      (balance.gastos_compras.total_compra + balance.gastos_compras.total_gasto + balance.prestamos_creditos.total_pagos)
      -
      ((balance.prestamos_creditos.total_deuda + balance.prestamos_creditos.total_intereses) - balance.prestamos_creditos.total_pagos)
    )
  }, [balance])

  const getBalance = async() => {
    const data = await BalanceService.getBalance();
    setBalance((b) => ({...b, ...data }));
  }

  const drawChart = () => {
    const total = balance.cortes.total_valor;
    const pagada = balance.cortes.total_pagos;
    const porCobrar = balance.cortes.total_valor - balance.cortes.total_pagos;
    
    var ctx = document.getElementById("kt_project_list_chart");

    // Init ChartJS -- for more info, please visit: https://www.chartjs.org/docs/latest/
    new Chart(ctx, {
      type: "doughnut",
      data: {
        datasets: [{ data: [total ? (pagada*100) / total: 0, total ? (porCobrar*100) / total: 0], backgroundColor: ["#00A3FF", "#50CD89"] }],
        labels: ["Fruta pagada", "Fruta por cobrar"],
      },
      options: {
        plugins: {
          legend: {
            display: false, // Oculta la leyenda
          },
        },
      },
    });
  }

  useEffect(() => {
    getBalance();
  }, []);
  useEffect(() => {
    if(balance.cortes.total_valor) {
      drawChart()
    }
  }, [balance]);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar" id="kt_toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <h1 className="text-gray-900 fw-bold my-1 fs-2">
                      Balance general
                      <small className="text-muted fs-6 fw-normal ms-1" />
                    </h1>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">Operación</li>
                      <li className="breadcrumb-item text-gray-900">
                        Balance general
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="container-xxl mb-5">
                <AlertPeriod />
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="row">
                    <div className="col">
                      <div className="card mb-5">
                        <div className="card-header pt-5">
                          <div className="card-title d-flex flex-column">
                            <span className="fs-2hx fw-bold text-gray-900 me-2 lh-1 ls-n2">
                              $ {UtilsService.numberFormat(balance.cortes.total_valor)}
                            </span>
                            <span className="text-gray-500 pt-1 fw-semibold fs-6">
                              Cortes
                            </span>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="d-flex flex-center h-100px me-5">
                              { balance.cortes.total_valor &&  <canvas id="kt_project_list_chart"></canvas> }
                              
                            </div>

                            <div className="d-flex flex-column content-justify-center flex-grow-1">
                              <div className="d-flex fs-6 fw-semibold align-items-center my-1">
                                <div
                                  className="bullet w-8px h-6px rounded-2 me-3"
                                  style={{
                                    backgroundColor: "#00A3FF",
                                  }}
                                />
                                <div className="fs-6 fw-semibold text-gray-500 flex-shrink-0">
                                  Fruta pagada
                                </div>
                                <div className="separator separator-dashed min-w-10px flex-grow-1 mx-2" />
                                <div className="ms-auto fw-bolder text-gray-700 text-end">
                                  $ {UtilsService.numberFormat(balance.cortes.total_pagos)}
                                </div>
                              </div>
                              <div className="d-flex fs-6 fw-semibold align-items-center">
                                <div
                                  className="bullet w-8px h-6px rounded-2 me-3"
                                  style={{
                                    backgroundColor: "#50CD89",
                                  }}
                                />
                                <div className="fs-6 fw-semibold text-gray-500 flex-shrink-0">
                                  Fruta por cobrar
                                </div>
                                <div className="separator separator-dashed min-w-10px flex-grow-1 mx-2" />
                                <div className="ms-auto fw-bolder text-gray-700 text-end">
                                  $ {UtilsService.numberFormat(balance.cortes.total_valor - balance.cortes.total_pagos)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card mb-5">
                        <div className="card-header pt-5">
                          <div className="card-title d-flex flex-column">
                            <span className="fs-2hx fw-bold text-gray-900 me-2 lh-1 ls-n2">
                              $ {UtilsService.numberFormat(balance.gastos_compras.total_compra + balance.gastos_compras.total_gasto)}
                            </span>
                            <span className="text-gray-500 pt-1 fw-semibold fs-6">Gastos y compras</span>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="fs-6 d-flex justify-content-between">
                            <div className="fw-semibold  ">Total Gastos </div>
                            <div className="d-flex fw-bold  ">
                              $ {UtilsService.numberFormat(balance.gastos_compras.total_gasto)}
                            </div>
                          </div>
                          <div className="separator separator-dashed my-4"></div>
                          <div className="fs-6 d-flex justify-content-between">
                            <div className="fw-semibold  ">Total compras </div>
                            <div className="d-flex fw-bold  ">
                              $ {UtilsService.numberFormat(balance.gastos_compras.total_compra)}
                            </div>
                          </div>
                          
                        </div>
                      </div>

                      <div className="card">
                        <div className="card-header pt-5">
                          <div className="card-title d-flex flex-column">
                            <span className="card-label fw-bold text-gray-800">
                            Préstamos y créditos
                            </span>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="fs-6 d-flex justify-content-between">
                            <div className="fw-semibold text-gray-600 ">Total de la deuda </div>
                            <div className="d-flex fw-bold text-gray-600 ">
                              $ {UtilsService.numberFormat(balance.prestamos_creditos.total_deuda + balance.prestamos_creditos.total_intereses)}
                            </div>
                          </div>
                          <div className="separator separator-dashed my-4"></div>
                          <div className="fs-6 d-flex justify-content-between">
                            <div className="fw-semibold text-gray-600 ">Total de depósitos </div>
                            <div className="d-flex fw-bold text-gray-600 ">
                              $ {UtilsService.numberFormat(balance.prestamos_creditos.total_pagos)}
                            </div>
                          </div>
                          <div className="separator separator-dashed my-4"></div>
                          <div className="fs-6 d-flex justify-content-between">
                            <div className="fw-semibold">Deuda por pagar </div>
                            <div className="d-flex fw-bold">
                              $ {UtilsService.numberFormat((balance.prestamos_creditos.total_deuda + balance.prestamos_creditos.total_intereses) - balance.prestamos_creditos.total_pagos)}
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </div>

                    <div className="col">
                      <div className="card h-full ">
                        <div className="card-body p-0">
                          <div
                            className="px-9 pt-6 card-rounded h-250px w-100 bgi-no-repeat bgi-size-cover bgi-position-y-top h-200px"
                            style={{
                              backgroundImage: balanceFinal > 0 ? "url('/assets/media/misc/bg-green.png')": "url('/assets/media/misc/bg-red.png')",
                            }}
                          >
                            <div className="fw-bold fs-xl text-center text-white pt-5">
                              Balance
                              <span className="fw-bolder fs-2hx d-block mt-n1">
                                $ {UtilsService.numberFormat(balanceFinal)}
                              </span>
                            </div>
                          </div>
                          <div
                            className="shadow-xs card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1 bg-body"
                            style={{ marginTop: "-100px" }}
                          >
                            <div className="d-flex align-items-center mb-9">
                              <div className="d-flex align-items-center w-100">
                                <div className="mb-1 pe-3 flex-grow-1">
                                  <div className="fs-4 text-gray-800  fw-bolder">
                                    Ingresos pagados
                                  </div>
                                  {/* <div className="text-gray-500 fw-semibold">
                                    Los ingresos es la suma de todos los cortes
                                    en este periodo
                                  </div> */}
                                </div>
                                <div className="d-flex align-items-center">
                                  <div className="fw-bold fs-4 text-gray-800 pe-1">
                                    $ {UtilsService.numberFormat(balance.cortes.total_pagos)}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mb-9">
                              <div className="d-flex align-items-center w-100">
                                <div className="mb-1 pe-3 flex-grow-1">
                                  <div className="fs-4 text-gray-800  fw-bolder">
                                    Egresos pagados
                                  </div>
                                  {/* <div className="text-gray-500 fw-semibold">
                                    Los egresos se componen de la suma de los
                                    gastos y compras más las deudas generadas
                                    por préstamos y créditos
                                  </div> */}
                                </div>
                                <div className="d-flex align-items-center">
                                  <div className="fw-bold fs-4 text-gray-800 pe-1">
                                    $ {UtilsService.numberFormat(balance.gastos_compras.total_compra + balance.gastos_compras.total_gasto + balance.prestamos_creditos.total_pagos)}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div className="d-flex align-items-center mb-9">
                              <div className="d-flex align-items-center w-100">
                                <div className="mb-1 pe-3 flex-grow-1">
                                  <div className="fs-4 text-gray-800  fw-bolder">
                                    Ingresos por cobrar
                                  </div>
                                  {/* <div className="text-gray-500 fw-semibold">
                                    Los ingresos es la suma de todos los cortes
                                    en este periodo
                                  </div> */}
                                </div>
                                <div className="d-flex align-items-center">
                                  <div className="fw-bold fs-4 text-gray-800 pe-1">
                                    $ {UtilsService.numberFormat(balance.cortes.total_valor - balance.cortes.total_pagos)}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mb-9">
                              <div className="d-flex align-items-center w-100">
                                <div className="mb-1 pe-3 flex-grow-1">
                                  <div className="fs-4 text-gray-800  fw-bolder">
                                  Egresos por pagar
                                  </div>
                                  {/* <div className="text-gray-500 fw-semibold">
                                    Los egresos se componen de la suma de los
                                    gastos y compras más las deudas generadas
                                    por préstamos y créditos
                                  </div> */}
                                </div>
                                <div className="d-flex align-items-center">
                                  <div className="fw-bold fs-4 text-gray-800 pe-1">
                                    $ {UtilsService.numberFormat((balance.prestamos_creditos.total_deuda + balance.prestamos_creditos.total_intereses) - balance.prestamos_creditos.total_pagos)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default BalancePage;
